import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from 'redux';
import * as loginActions from '../store/modules/loginSlice';
import { readLoginSession, LOGOUT_EVENT, SESSION_REQUEST_TIMEOUT } from './libs/useSessionValidation';

import { showToast } from './Common/Messages';

import SearchPanel from './SearchPanels/SearchPanel';

export const NavMenu = (props) => {
    //page
    const location = useLocation();
    const history = useNavigate();
    //redux
    const LoginStates = useSelector(state => state.login);

    const dispatch = useDispatch();
    const LoginActions = bindActionCreators(loginActions, dispatch);

    const [menuList, setMenuList] = useState([]);
    const [isScrolled, setIsScrolled] = useState(false);
    const [myMenuVisible, setMyMenuVisible] = useState(false);
    const [isLoggingOut, setIsLoggingOut] = useState(false);
    const [myFavVisible, setMyFavVisible] = useState(false);
    const [searchExpand, setSearchExpand] = useState(false);
    const [searchContent, setSearchContent] = useState("");
    const [menuMode, setMenuMode] = useState('');
    const [isShown, setIsShown] = useState(false);
    const [bookmarksList, setBookmarksList] = useState(null);

    const wrapperRef = useRef(null);
    const searchRef = useRef(null);

    useEffect(() => {
        const container = document.querySelector(".wrapper");
        document.addEventListener('mousedown', handleClickOutside);
        container.addEventListener("scroll", handleScroll);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            container.removeEventListener("scroll", handleScroll);
        }
    }, []);

    useEffect(() => {
        if (props.menuData.length > 0) {
            setTopMenu(props.menuData);
        }
    }, [props.menuData, LoginStates.sessionId]);

    useEffect(() => {
        if (bookmarksList) {
            setMyFavVisible(!myFavVisible);
        }
    }, [bookmarksList]);

    const goToDocumentLink = (linkPath) => {
        setMyFavVisible(false);
        window.open(linkPath);
    }

    const getBookmarks = async () => {
        const body = {
            devUserId: LoginStates.userId
        };
        fetch(`api/Document/GetFavoriteManualFolder`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(body)
        }).then((response) => response.json())
            .then(resultData => {
                const mystyle = {
                    position: "absolute",
                    top: "70px",
                    right: "20px"
                }
                if (resultData.data.table1.length > 0 && resultData.data.table1[0].folderItemSeq !== 0) {   
                    setBookmarksList(
                        <div className="bmrk-cnts" style={mystyle} ref={wrapperRef}>
                            <div className="bmrk-title-wrap">
                                <Link to={'/MyPage/myBookmarks'} onClick={() => setMyFavVisible(false) }>
                                    <h3 className='bmrk-title'>즐겨찾기한 매뉴얼</h3>
                                    <i className='icoKdc20 seemore-m'></i>
                                </Link>
                            </div>
                            <div class="bmrk-list-scrollbox">
                                <ul className='bmrk-list-wrap'>
                                    {resultData.data.table1.map((item) => {
                                        if (!item.fullPath || !item.fullPath.trim()) {
                                            return null;
                                        }
                                        const fullPath = JSON.parse(item.fullPath);
                                        return (
                                            <li key={item.folderItemSeq} className="bmrk-list-each" onClick={() => goToDocumentLink(item.linkPath)}>
                                                <button className="bmrk-btn">
                                                    <i className="icoKdc16 star-b"></i>
                                                </button>
                                                <div className="doc-info">
                                                    {fullPath && (
                                                        <div className="doc-path">
                                                            {fullPath.map((path, index) => (
                                                                <React.Fragment key={index}>
                                                                    <span className="doc-path-text">{path}</span>
                                                                    {index < fullPath.length - 1 && <i className="icoKdc12 next"></i>}
                                                                </React.Fragment>
                                                            ))}
                                                        </div>
                                                    )}
                                                    <p className="doc-title">{item.title}</p>
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    );
                } else {
                    setBookmarksList(
                        <div className="bmrk-cnts" style={mystyle} ref={wrapperRef}>
                            <div className="bmrk-title-wrap">
                                <h3 className='bmrk-title'>즐겨찾기한 매뉴얼</h3>
                                <i className='icoKdc20 seemore-m'></i>
                            </div>
                            <div className='bmrk-empty'>
                                <i className='icoKdc80 empty'></i>
                                <span>즐겨찾기한 내역이 없습니다.</span>
                            </div>
                        </div>
                    );
                }
            });
    }

    // 스크롤 이벤트 핸들러
    const handleScroll = (e) => {
        const scrollThreshold = 100; // 스크롤 변경 임계값 (200px)      
        if (e.target.scrollTop > scrollThreshold) {
            setIsScrolled(true);
        } else {
            setIsScrolled(false);
        }
    };
    const handleClickOutside = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target) && event.target.className !== 'profile-img') {
            setMyMenuVisible(false);
        }
        if (searchRef.current && !searchRef.current.contains(event.target) && event.target.className !== 'icoKdcMask24 magnifier') {
            setSearchExpand(false);
        }
        if (wrapperRef.current && !wrapperRef.current.contains(event.target) && event.target.className !== 'icoKdcMask24 star-fill-24') {
            setMyFavVisible(false);
        }
    }
    const showSearchPanel = () => {
        setSearchExpand(!searchExpand);
    }
    const searchPanel = () => {
        if (searchExpand) {
            return (
                <SearchPanel searchRef={searchRef} panelClose={showSearchPanel} />
            );
        }
        else {
            return null;
        }
    }
    const checkAdmin = () => {
        const moveToAdmin = () => {
            showMenu();
            window.open("/Manager");
        }
        const adminList = LoginStates.admin ? LoginStates.admin.split(',') : [];
        const isAdmin = adminList.length > 0
        if (isAdmin) {
            return (
                <a onClick={moveToAdmin}><i className={`icoKdcMask24 setting`}></i></a>
            );
        }
    };
    const setMenuItem = (item, index) => {
        const mouseHover = (e) => {
            const lnb = document.getElementsByName(`lnb-${index}`)[0];
            if (lnb !== undefined)
                lnb.style.display = 'block';
        }
        const mouseLeave = (e) => {
            const lnb = document.getElementsByName(`lnb-${index}`)[0];
            if (lnb !== undefined)
                lnb.style.display = 'none';
        }
        const handleClick = (mainRoute, subRoute) => {
            history(`/${item.route}/${subRoute.route}`);
        };
        return (
            <li key={index} onMouseEnter={(e) => mouseHover(e)} onMouseLeave={(e) => mouseLeave(e)}>
                <Link to={`/${item.route}`} state={{ data: item }}>
                    {item.title}
                </Link>
                {
                    item.submenu && item.hasSub ?
                        <div className='lnb' name={`lnb-${index}`} onMouseLeave={(e) => mouseLeave(e)}>
                            <ul className='lnb-list'>
                                {item.submenu.filter(sub => sub.visible !== false).map((sub, index) => {
                                    return (
                                        <li key={index} className="sub" onClick={() => handleClick(item, sub)} style={{ cursor: 'pointer' }}>
                                            {sub.title}
                                        </li>
                                    );
                                }
                                )}
                            </ul>
                        </div>
                        : null
                }
            </li>
        );
    }
    const setTopMenu = (menuData) => {
        setMenuList(
            <ul className="nav-list">
                {
                    menuData.map((x, index) => {
                        if (x?.visible === false)
                            return null;
                        return setMenuItem(x, index);
                    })
                }
            </ul>
        );
    };

    const handleChange = (e) => {
        setSearchContent(e.target.value);
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            showToast('success', 'searching...');
            history("/Search", {
                state: e.target.value
            });
            setSearchContent('');
        }
    };
    const showUserInfo = () => {
        setMyMenuVisible(!myMenuVisible);
    }
    const showFavInfo = () => {
        getBookmarks();
    }
    const getLoginButton = () => {
        if (!LoginStates.sessionId || LoginStates.sessionId === '') {
            return (
                <div className="side-menu">
                    <div className="side-btns">
                        <Link onClick={showSearchPanel}><i className={`icoKdcMask24 magnifier`}></i></Link>
                        <Link to="/News"><i className={`icoKdcMask24 megaphone`}></i></Link>
                        <a onClick={login} className="btnLogin">로그인</a>
                    </div>
                </div>
            );
        }
        else {
            const mystyle = {
                position: "absolute",
                top: "70px",
                right: "20px"
            }
            const edithomebutton = {
                width: '120px',
                height: '28px',
                backgroundImage: 'url(./content/images/logo-kdceditor.svg)',
                backgroundRepeat: 'no-repeat',
                backgroundColor: 'transparent',
                backgroundSize: 'contain'
            }

            return (
                <div className="side-menu">
                    <div className="side-btns">
                        <Link onClick={showSearchPanel}><i className={`icoKdcMask24 magnifier`}></i></Link>
                        <Link onClick={(e) => showFavInfo(e)}><i className={`icoKdcMask24 ${myFavVisible ? 'star-fill-24' : 'star-24'}`}></i></Link>
                        {myFavVisible ? bookmarksList : null}
                        {checkAdmin()}
                        <Link to="/News"><i className={`icoKdcMask24 megaphone`}></i></Link>
                        {LoginStates.userRole?.includes('Ylw') &&
                            <Link onClick={() => openKbot()}><i className={`icoKdc32 chatbot`}></i></Link>
                        }
                    </div>
                    <div className="profile-img" onClick={(e) => showUserInfo(e)}>{LoginStates.userId.substring(0, 1).toUpperCase()}</div>

                    {myMenuVisible
                        ?
                        <div className="mypage-list" style={mystyle} ref={wrapperRef}>
                            <ul className='mypage-context-menu'>
                                <a onClick={e => onClickMymenuList(e, () => { history('/MyPage/myBookmarks') })}>
                                    마이페이지
                                </a>
                                <a onClick={e => logout(e)}>로그아웃</a>
                                {
                                    LoginStates.userRole?.includes('Editor') ?
                                        <>
                                            <div className='border'></div>
                                            <a onClick={e => onClickMymenuList(e, () => { window.open('/EditCenter') })}>
                                                <div style={edithomebutton}></div>
                                            </a>
                                        </>
                                        : null
                                }
                            </ul>
                        </div>
                        :
                        null
                    }
                </div>
            );
        }
    };
    const openKbot = () => {
        props.setKbotFrame((prev) => !prev);
    }
    const onClickMymenuList = (e, action) => {
        e.preventDefault();
        action();
        setMyMenuVisible(false);
    }
    const login = (e) => {
        e.preventDefault();
        if (location.pathname === "/Login") {
            history(0);
        }
        history("/Login");
    }
    const logout = async (e) => {
        e.preventDefault();
        if (isLoggingOut) return;
        setIsLoggingOut(true);
        setMyMenuVisible(false);
        props.setKbotFrame(false);
        const body = {
            userId: encodeURI(LoginStates.userId),
            sessionID: encodeURI(LoginStates.sessionId)
        }
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), SESSION_REQUEST_TIMEOUT);
        let succeeded = false;
        try {
            const response = await fetch('api/Login/DeleteUserSession', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            credentials: 'include',
            signal: controller.signal,
            body: JSON.stringify(body)
            });
            succeeded = response.ok || response.status === 401;
        } catch {
            succeeded = false;
        } finally {
            window.clearTimeout(timeout);
            setIsLoggingOut(false);
            const currentSession = readLoginSession();
            if (!currentSession || currentSession.sessionId === LoginStates.sessionId) {
                showToast(succeeded ? 'success' : 'warning', succeeded ? '로그아웃 되었습니다.' : '이 브라우저에서 로그아웃했습니다. 서버 로그아웃 처리는 확인하지 못했습니다.', 3000);
                sendMessageToIframe();
                window.localStorage.removeItem("loginsession");
                LoginActions.init();
                localStorage.removeItem("loginStates");
                localStorage.removeItem("simpleViewStates");
                sessionStorage.removeItem('reduxState');
                sessionStorage.removeItem('kdcCookieOtpRequestedAt');
                window.dispatchEvent(new Event(LOGOUT_EVENT));
                history("/");
            }
        }
    }
    const sendMessageToIframe = () => {
        const msg = {
            fn: "req_ylwopenwebui_cleartoken"
        };
        // iframe의 contentWindow에 메시지를 전달
        if (props.iframeRef?.current?.contentWindow) {
            props.iframeRef.current.contentWindow.postMessage(
                msg,
                props.kbotUrl // iframe의 출처
            );
        }
    };

    const showMenu = () => {
        if (menuMode === '' && window.innerWidth < 1100) {
            setMenuMode('menu-mode');
        } else {
            setMenuMode('');
        }
    };
    if (location.pathname !== "/") {
        return (
            <header className="inside">
                <div className="header-wrap white">
                    <Link to="/"><i className="header-logo"></i></Link>
                    <nav>
                        {menuList}
                    </nav>
                    {getLoginButton()}
                </div>
                {searchPanel()}
            </header>
        );
    }
    let mainClass = '';
    if (isScrolled)
        mainClass = 'inside fixed';
    else if (searchExpand)
        mainClass = 'inside';

    return (
        <header className={mainClass}>
            <div className="header-wrap">
                <Link to="/"><i className="header-logo"></i></Link>
                <nav>
                    {menuList}
                </nav>
                {getLoginButton()}
            </div>
            {searchPanel()}
        </header>
    );
};

export default NavMenu;
